import { styled } from '@mui/material/styles'
import { Modal, themeSpacing } from 'eezy-components'

export const Container = styled(Modal)``

export const Image = styled('img')`
  width: 75%;
  height: 75%;
  object-fit: cover;
`

export const LoadingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${themeSpacing(8)};
`
